module.exports = __webpack_public_path__ + "img/1691832178132-image.jpg.6e92ca49.webp";